module.exports = __webpack_public_path__ + "img/financial.14a7ac16.svg";